import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule, Http } from '@angular/http';
import { TranslateService, TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate/ng2-translate';
import { Ng2OverlayModule } from 'ng2-overlay';

import { AppComponent } from './app.component';

import { AuthGuard } from './shared/services/authguard.service';
import { AuthService } from './shared/services/authentication.service';
import { UserService } from './shared/services/user/user.service';
import { GroupService } from './shared/services/group/group.service';
import { NotificationService } from './shared/services/notification.service';
import { SettingsService } from './shared/services/settings.service';
import { AppSettingsService } from './shared/services/appsettings.service';
import { ClientService } from './shared/services/client/client.service';
import { SurveyService } from './shared/services/survey/survey.service';
import { CategoryService } from './shared/services/survey/category.service';
import { ConsultationService } from './shared/services/survey/consultation.service';


import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { SharedModule } from './shared/shared.module';
import { RoutesModule } from './routes/routes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// https://github.com/ocombe/ng2-translate/issues/218
export function createTranslateLoader(http: Http) {
    return new TranslateStaticLoader(http, './assets/i18n', '.json');
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        BrowserModule,
        CoreModule,
        LayoutModule,
        SharedModule.forRoot(),
        RoutesModule,
        Ng2OverlayModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [Http]
        })
    ],
    providers: [
        AuthGuard,
        AuthService,
        UserService,
        GroupService,
        NotificationService,
        AppSettingsService,
        SettingsService,
        ClientService,
        SurveyService,
        SettingsService,
        CategoryService,
        ConsultationService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/app.module.ts